import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenu } from '@angular/material/menu';
import { Menu } from 'src/app/@shared/models/menu.model';

@Component({
  selector: 'app-pesquisa-menu',
  templateUrl: './modal-pesquisa-menu.component.html',
  styleUrls: ['./modal-pesquisa-menu.component.scss']
})
export class ModalPesquisaMenuComponent implements OnInit {
  @ViewChild('menu', { static: true }) menu: MatMenu;
  @Input() items: Menu[];
  filteredItems: Menu[];
  pesquisa: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalPesquisaMenuComponent>) { }

  ngOnInit() {
    this.items = this.data.items.map(item => ({
      ...item,
      tag: item.tag || '',
      menuChildrenOutput: item.menuChildrenOutput || []
    }));

    this.pesquisa = this.data.search;
    this.filtrarMenu()
  }

  filtrarMenu() {
    this.filteredItems = this.items
      .map(item => this.filtrarMenuItem(item))
      .filter(item => item !== null) as Menu[];
  }

  filtrarMenuItem(item: Menu): Menu | null {
    const itemTag = item.tag || '';
    if (itemTag.toLowerCase().includes(this.pesquisa.toLowerCase())) {

      return item;
    }

    if (item.menuChildrenOutput) {
      const filteredChildren = item.menuChildrenOutput
        .map(child => this.filtrarMenuItem(child))
        .filter(child => child !== null) as Menu[];

      if (filteredChildren.length > 0) {
        return {
          ...item,
          menuChildrenOutput: filteredChildren,
        };
      }
    }

    return null;
  }



  closeModal(): void {
    this.dialogRef.close();
  }
}
